import React, { useState, useContext } from "react";

// COMPONENT
import AddPlayeurModal from "../addPlayeurModal/AddPlayeurModal";
import InfoPlayeurModal from "../InfoPlayeurModal/InfoPlayeurModal";
import DeletePlayeurModal from "../deletePlayeurModal/DeletePlayeurModal";

// CONTEXT
// FUNCTION
import {
  convertLevelToWord,
  convertLevelToColor,
} from "../../../../functions/convertLevelToWord";

// ICONS
import { FaTrash } from "react-icons/fa";
import { AllDataUsers } from "../../../../context/AllDataUsers";

//FIREBASE
import { doc, getDoc, updateDoc } from "firebase/firestore";

import { db } from "../../../../config/firebase-config";

export default function ScheduleItemAdmin({ schedule }) {
  const {
    day,
    startHour,
    endHour,
    educator,
    numberOfPlaces,
    level,
    playedForm,
    usersRegisted,
    uid,
    acceptProposition,
  } = schedule;

  // Calculer le nombre de places restantes
  const remainingPlaces = Math.max(0, numberOfPlaces - usersRegisted.length);

  // Créer un tableau avec les éléments de usersRegisted et des cases vides
  const tableData = Array.from(usersRegisted).concat(
    Array(remainingPlaces).fill(""),
  );

  // state pour les modal
  const [modal1, setShowModal1] = useState(false);
  const [modal2, setShowModal2] = useState(false);
  const [modal3, setShowModal3] = useState(false);

  const [playeurClick, setPlayeurClick] = useState("");

  //TOGGLE PROPOSITION
  const handleToggleAcceptProposition = async (name) => {
    try {
      const scheduleRef = doc(db, "schedules", uid);

      const scheduleSnap = await getDoc(scheduleRef);

      if (!scheduleSnap.exists()) {
        console.log("Schedule introuvable");
        return;
      }

      const scheduleData = scheduleSnap.data();

      const acceptProposition = scheduleData.acceptProposition || [];

      const newAcceptProposition = acceptProposition.includes(name)
        ? acceptProposition.filter((currentName) => currentName !== name)
        : [...acceptProposition, name];

      await updateDoc(scheduleRef, {
        acceptProposition: newAcceptProposition,
      });

      console.log("acceptProposition mis à jour");
    } catch (error) {
      console.error("Erreur lors du toggle :", error);
    }
  };
  return (
    <>
      <div className="schedule-card">
        <div className="header-card">
          <h2>
            {day} de {startHour} à {endHour}
          </h2>
          <div>
            <p>{educator}</p>
            <p>{convertLevelToWord(level)}</p>
            <p>{playedForm === "0" ? "Classique" : "Forme jouée"}</p>
          </div>
        </div>
        <table style={{ backgroundColor: convertLevelToColor(level) }}>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} style={{ height: "50px" }}>
                  <td
                    style={{
                      color: acceptProposition.includes(item.name?.trim())
                        ? "green"
                        : null,
                    }}
                    className="item"
                    onClick={() =>
                      item
                        ? (setShowModal2(true), setPlayeurClick(item))
                        : setShowModal1(true)
                    }
                  >
                    {item.name}
                  </td>
                  <td className="birthDay no-print">
                    {level >= 10 &&
                    ![61, 62, 71, 72, 81, 82].includes(Number(level)) &&
                    item.name ? (
                      <span title="Valider l'inscription">
                        <input
                          type="checkbox"
                          style={{ accentColor: "green" }}
                          checked={
                            schedule.acceptProposition?.includes(
                              item.name?.trim(),
                            ) || false
                          }
                          onClick={(e) => e.stopPropagation()}
                          onChange={(e) => {
                            e.stopPropagation();
                            handleToggleAcceptProposition(item.name);
                          }}
                          className="checkbox-green"
                        />
                      </span>
                    ) : (
                      ""
                    )}
                  </td>
                  <td>
                    {item.birthDay
                      ? item.birthDay.includes("-")
                        ? item.birthDay.slice(0, 4)
                        : item.birthDay.slice(-4)
                      : ""}
                  </td>
                  {item && (
                    <td
                      className="icon no-print"
                      onClick={() => {
                        setShowModal3(true);
                        setPlayeurClick(item);
                      }}
                    >
                      <FaTrash />
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {modal1 && (
        <AddPlayeurModal
          uid={uid}
          usersRegisted={usersRegisted}
          numberOfPlaces={numberOfPlaces}
          level={level}
          setShowModal1={setShowModal1}
        />
      )}
      {modal2 && (
        <InfoPlayeurModal
          playeurClick={playeurClick.name.toLowerCase().trim()}
          setShowModal2={setShowModal2}
        />
      )}
      {modal3 && (
        <DeletePlayeurModal
          playeurToDelete={playeurClick}
          uid={uid}
          setShowModal3={setShowModal3}
          schedule={schedule}
        />
      )}
    </>
  );
}
